var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"500","title":"无权限","sub-title":"抱歉, 您暂无访问权限，请联系管理员"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toLogin}},[_vm._v(" 重新登陆 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }